<label for="stripeCardInfo">Enter new card information below</label>
<div id="card-element" class="form-control"></div>
<div id="card-errors" role="alert"></div>
